import _ from 'lodash'

export default {
    methods: {
        getTranslationFromJSONString (translationString, localeKey) {
            let translation = ''
            let translationsParsed = {}

            if (!translationString || _.isEmpty(translationString) || !_.isString(translationString)) {
                return ''
            }

            try {
                translationsParsed = JSON.parse(translationString)
            } catch (ex) {
                return '--'
            }

            translation = translationsParsed[localeKey]

            if (translation === undefined || _.isEmpty(translation)) {
                return '--'
            }

            return translation
        },

        JSONParseTranslations(string, key) {
            let translation = string
            try {
                let langstring = JSON.parse(string)[key]
                translation = _.isEmpty(langstring) ? '--' : langstring
            } catch (ex) {
                // console.error(ex)
            }

            return translation
        },

        objectKeyTranslation(translations, objectKey, localeKey) {
            let translated = ''
            let translation = translations[localeKey]
            try {
                translated = _.isEmpty(translation) ? '--' : translation[objectKey]
            } catch (ex) {
                // console.error(ex)
            }

            return translated
        },
    }
}